import React, { useState } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Popover,
} from "@material-ui/core";
import InjectStore from "../../../common/utils/InjectStore";
import CriteriaPanel from "app/list/common/Criteria/CriteriaPanel";
import { toJS } from "mobx";
import styled from "styled-components";

function CriteriaPopup({
  store,
  anchorEl,
  handleClose,
  criteria,
  columns,
  reminderKey,
  ...props
}) {
  const [newCriteria, setNewCriteria] = React.useState(criteria);
  const currentLisId = store.listId;

  const starColumn = columns.filter((col) => {
    const options = typeof col.options === 'string' ? JSON.parse(col.options)[0] : col.options;
    return options?.is_star_column === true && col.list_id === currentLisId;
  });

  const nonStarColumns = columns.filter((col) => {
    const options = typeof col.options === 'string' ? JSON.parse(col.options)[0] : col.options;
    return !options?.is_star_column || col.list_id !== currentLisId;
  });

  let idColumnIndex = nonStarColumns.findIndex(col => col.name.toLowerCase() === 'id');
  let modifiedColumns;
  if (idColumnIndex !== -1) {
    nonStarColumns.splice(idColumnIndex + 1, 0, ...starColumn);
    modifiedColumns = [...nonStarColumns];
  } else {
    modifiedColumns = [...starColumn, ...nonStarColumns];
  }
  
  const handleChange = React.useCallback(
    (val) => {
      setNewCriteria(val);
    },
    [setNewCriteria]
  );

  const handleSave = () => {
    props.handleChange(newCriteria);
    handleClose();
  };

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      transformOrigin={
        reminderKey && reminderKey > 4
          ? {
              vertical: "bottom",
              horizontal: "left",
            }
          : {
              vertical: "top",
              horizontal: "left",
            }
      }
      PaperProps={{
        style: {
          // maxWidth: 500,
          // minWidth: 400
          width: "53vw",
        },
      }}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle id="draggable-dialog-title">
        Enable Reminder Only If...
      </DialogTitle>
      <StyledDialogContent
        reminderKey={reminderKey}
      >
        <Grid container>
          <Grid item xs={12}>
            <CriteriaPanel
              onChange={handleChange}
              value={typeof criteria === "object" ? toJS(criteria) : criteria}
              lookupColumns={modifiedColumns}
              lookupListId={currentLisId}
              // currentSheetColumns={columnsForCriteriaPanel}
              // currentListId={listId}
              hiddenMultiLevels={true}
              floatingCriteriaButton
            />
          </Grid>
        </Grid>
      </StyledDialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Popover>
  );
}

export default InjectStore(CriteriaPopup);

const StyledDialogContent = styled(DialogContent)`
  max-height: ${({reminderKey})=> reminderKey && reminderKey > 2 ? "45vh" : `${44 - 2* reminderKey}vh`};
`;